import {
  Message
} from 'view-ui-plus'

let mapInstance = null
let editorInstance = null
let polygonLayer = null

/**
 * 获取或创建地图实例（单例）
 */
export function getMap(container, center_location) {
  // if (!mapInstance) {
  //   mapInstance = new TMap.Map(container, {
  //     zoom: 12,
  //     center: new TMap.LatLng(28.194572,112.97639)
  //   })
  // }
  if (center_location.length == 0) {
    mapInstance = new TMap.Map(container, {
      zoom: 12,
      center: new TMap.LatLng(28.194572, 112.97639)
    })
  } else {
    mapInstance = new TMap.Map(container, {
      zoom: 18,
      center: new TMap.LatLng(center_location[0], center_location[1])
    })
  }

  return mapInstance
}

/**
 * 初始化多边形编辑器（官方写法：MultiPolygon 内嵌在 overlayList 中）
 * @param {TMap.Map} map
 * @param {Array} existPaths - 已有多边形数据 [{lat, lng}, ...] 或 [[[{lat,lng},...], [{lat,lng},...]], ...]（带洞）
 * @param {string} actionMode - 初始模式，默认 DRAW
 * @returns {TMap.tools.GeometryEditor}
 */
export function initPolygonEditor(map, existPaths, actionMode) {
  destroyEditor()

  const mode = actionMode || TMap.tools.constants.EDITOR_ACTION.DRAW

  const geometries = (existPaths && existPaths.length)
    ? existPaths.map((paths, i) => ({
      id: 'polygon_' + i,
      paths: toLatLngPaths(paths)
    }))
    : []

  polygonLayer = new TMap.MultiPolygon({
    map,
    styles: {
      highlight: new TMap.PolygonStyle({
        color: 'rgba(255, 255, 0, 0.6)'
      })
    },
    geometries
  })

  editorInstance = new TMap.tools.GeometryEditor({
    map,
    overlayList: [{
      overlay: polygonLayer,
      id: 'polygon',
      selectedStyleId: 'highlight'
    }],
    actionMode: geometries.length ? TMap.tools.constants.EDITOR_ACTION.INTERACT : mode,
    activeOverlayId: 'polygon',
    selectable: true,
    snappable: true
  })

  return { editor: editorInstance, layer: polygonLayer }
}

/** 递归将 {lat,lng} 普通对象转为 TMap.LatLng */
function toLatLngPaths(paths) {
  if (!paths || !paths.length) return []
  // 如果是多层（带洞多边形）: [[{lat,lng},...], [{lat,lng},...]]
  if (Array.isArray(paths[0]) && paths[0][0] && typeof paths[0][0].lat === 'number') {
    return paths.map(ring => ring.map(p => new TMap.LatLng(p.lat, p.lng)))
  }
  // 单层路径
  return paths.map(p => new TMap.LatLng(p.lat, p.lng))
}

/** 将 LatLng 递归转回 {lat,lng} */
function toPlainPaths(latLngPaths) {
  if (!latLngPaths || !latLngPaths.length) return []
  if (Array.isArray(latLngPaths[0]) && typeof latLngPaths[0][0] !== 'number') {
    return latLngPaths.map(ring => ring.map(c => ({ lat: c.getLat(), lng: c.getLng() })))
  }
  return latLngPaths.map(c => ({ lat: c.getLat(), lng: c.getLng() }))
}

/**
 * 获取当前所有多边形的路径（纯 {lat,lng} 对象，安全序列化）
 */
export function getAllPolygonPaths() {
  if (!polygonLayer) return []
  const geos = polygonLayer.getGeometries() || []
  return geos.map(g => toPlainPaths(g.paths))
}

/**
 * 删除选中的多边形（与官网一致：editor.delete()）
 */
export function deleteSelectedPolygon() {

  if (editorInstance) {
    console.log('请先点击多边形，选中之后再删除1')
    editorInstance.delete()
  }
}

/**
 * 将编辑器切换到 DRAW 绘制模式
 */
export function startDrawMode() {
  if (editorInstance) {
    editorInstance.stop()
    editorInstance.setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW)
  }
}

/**
 * 将编辑器切换到 INTERACT 交互模式
 */
export function startInteractMode() {
  if (editorInstance) {
    editorInstance.stop()
    editorInstance.setActionMode(TMap.tools.constants.EDITOR_ACTION.INTERACT)
  }
}

/**
 * 销毁编辑器并清理图层
 */
export function destroyEditor() {
  if (editorInstance) {
    editorInstance.destroy()
    editorInstance = null
  }
  if (polygonLayer) {
    polygonLayer.setMap(null)
    polygonLayer = null
  }
}


/**
 * 清除所有多边形，切回 DRAW 绘制模式（不销毁地图）
 */
export function clearAllPolygons() {
  if (polygonLayer) {
    polygonLayer.setGeometries([])
  }
  if (editorInstance) {
    editorInstance.stop()
    editorInstance.setActionMode(TMap.tools.constants.EDITOR_ACTION.DRAW)
  }
}


// ✅ 新增
export function destroyMap() {
  if (mapInstance) {
    mapInstance.destroy()
    mapInstance = null
  }
}

